var map = {
	"./Avatars": 2399,
	"./Avatars.stories": 65046,
	"./Avatars.stories.tsx": 65046,
	"./Avatars.tsx": 2399,
	"./NFT": 54081,
	"./NFT.tsx": 54081,
	"./TheArtist.png": 45253,
	"./TheArtistTest.png": 91229,
	"./TheGenius.png": 51407,
	"./TheGeniusTest.png": 62963,
	"./ThePoet.png": 92348,
	"./ThePoetTest.png": 76420,
	"./TheProfessor.png": 86673,
	"./TheProfessorTest.png": 89233,
	"./TheQueen.png": 64964,
	"./TheQueenTest.png": 4012,
	"./mystery.png": 9362,
	"./mystery1.png": 54321,
	"./mystery1Test.png": 87505,
	"./mysteryTest.png": 53726,
	"./videos/Monsoon.mp4": 91586,
	"./videos/Science.mp4": 88567,
	"./videos/Space.mp4": 27451,
	"./videos/Summer.mp4": 63118,
	"./videos/Winter.mp4": 71006,
	"./videos/ape.mp4": 87537,
	"./videos/eagle.mp4": 67845,
	"./videos/rhino.mp4": 48511,
	"./videos/shark.mp4": 62918,
	"./videos/tiger.mp4": 41988,
	"assets/avatars/Avatars.stories": 65046,
	"assets/avatars/Avatars.stories.tsx": 65046,
	"assets/avatars/Avatars.tsx": 2399,
	"assets/avatars/NFT.tsx": 54081,
	"assets/avatars/TheArtist.png": 45253,
	"assets/avatars/TheArtistTest.png": 91229,
	"assets/avatars/TheGenius.png": 51407,
	"assets/avatars/TheGeniusTest.png": 62963,
	"assets/avatars/ThePoet.png": 92348,
	"assets/avatars/ThePoetTest.png": 76420,
	"assets/avatars/TheProfessor.png": 86673,
	"assets/avatars/TheProfessorTest.png": 89233,
	"assets/avatars/TheQueen.png": 64964,
	"assets/avatars/TheQueenTest.png": 4012,
	"assets/avatars/mystery.png": 9362,
	"assets/avatars/mystery1.png": 54321,
	"assets/avatars/mystery1Test.png": 87505,
	"assets/avatars/mysteryTest.png": 53726,
	"assets/avatars/videos/Monsoon.mp4": 91586,
	"assets/avatars/videos/Science.mp4": 88567,
	"assets/avatars/videos/Space.mp4": 27451,
	"assets/avatars/videos/Summer.mp4": 63118,
	"assets/avatars/videos/Winter.mp4": 71006,
	"assets/avatars/videos/ape.mp4": 87537,
	"assets/avatars/videos/eagle.mp4": 67845,
	"assets/avatars/videos/rhino.mp4": 48511,
	"assets/avatars/videos/shark.mp4": 62918,
	"assets/avatars/videos/tiger.mp4": 41988
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99866;